import { c as _c } from "react/compiler-runtime";
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import requestIdleCallback from 'commons/requestIdleCallback';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import LoadMoreButton from 'components/consumer/LoadMoreButton';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import ProductsGridLoading from './components/ProductsGridLoading';
import ProductsGrid from './components/ProductsGrid';
const ProductsGridStatic = t0 => {
  const $ = _c(23);
  const {
    className,
    columnsOnDesktop: t1,
    columnsOnMobile: t2,
    hasMoreProducts,
    layout: t3,
    listName,
    loading,
    loadingMore,
    loadMore,
    maxCardsCount,
    productsData
  } = t0;
  const columnsOnDesktop = t1 === undefined ? "4" : t1;
  const columnsOnMobile = t2 === undefined ? "2" : t2;
  const layout = t3 === undefined ? "" : t3;
  const itemContainerRef = useRef();
  let t4;
  let t5;
  if ($[0] !== hasMoreProducts || $[1] !== loadMore || $[2] !== loading) {
    t4 = () => {
      if (!(loading || !loadMore || !hasMoreProducts)) {
        setTimeout(() => {
          requestIdleCallback(() => {
            if (hasMoreProducts) {
              loadMore?.();
            }
          });
        }, 5000);
      }
    };
    t5 = [loading, loadMore, hasMoreProducts];
    $[0] = hasMoreProducts;
    $[1] = loadMore;
    $[2] = loading;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  const t6 = layout === "favorite";
  const t7 = listName === "SideBar";
  const t8 = !!className;
  let t9;
  if ($[5] !== className || $[6] !== t6 || $[7] !== t7 || $[8] !== t8) {
    t9 = classNames("md:mt-2", {
      "!w-full max-[767px]:!mt-2.5": t6,
      "!mt-4 md:!mt-2": t7,
      [className]: t8
    });
    $[5] = className;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== columnsOnDesktop || $[11] !== columnsOnMobile || $[12] !== hasMoreProducts || $[13] !== layout || $[14] !== loadMore || $[15] !== loading || $[16] !== loadingMore || $[17] !== maxCardsCount || $[18] !== productsData) {
    t10 = <div className="mx-auto my-0">{loading ? <ProductsGridLoading cardsCount={maxCardsCount} columnsOnDesktop={columnsOnDesktop} columnsOnMobile={columnsOnMobile} itemContainerRef={itemContainerRef} /> : <><ProductCardGridUI columnsOnDesktop={columnsOnDesktop ?? 4} columnsOnMobile={columnsOnMobile ?? 2} limitWidth={false} containerRef={itemContainerRef}><ProductsGrid eagerImageCount={12} productsData={productsData} loading={loadingMore} maxCardsCount={maxCardsCount} layout={layout} /></ProductCardGridUI>{hasMoreProducts && !!loadMore && <><VisuallyHidden>On activating the Load more products button, the content above will be updated</VisuallyHidden><LoadMoreButton onClick={() => {
            const indexToFocus = productsData.length;
            loadMore();
            setTimeout(() => {
              const elementToFocus = itemContainerRef.current?.children[indexToFocus];
              if (elementToFocus) {
                elementToFocus.focus();
              }
            }, 10);
          }} aria-label="Load more products" /></>}</>}</div>;
    $[10] = columnsOnDesktop;
    $[11] = columnsOnMobile;
    $[12] = hasMoreProducts;
    $[13] = layout;
    $[14] = loadMore;
    $[15] = loading;
    $[16] = loadingMore;
    $[17] = maxCardsCount;
    $[18] = productsData;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = <div data-xc="products-grid" className={t9}>{t10}</div>;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
ProductsGridStatic.propTypes = {
  className: PropTypes.string,
  columnsOnDesktop: PropTypes.oneOf(['2', '3', '4']),
  columnsOnMobile: PropTypes.oneOf(['1', '2']),
  hasMoreProducts: PropTypes.bool,
  layout: PropTypes.string,
  listName: PropTypes.string,
  loading: PropTypes.bool,
  loadMore: PropTypes.func,
  loadingMore: PropTypes.bool,
  maxCardsCount: PropTypes.number,
  productsData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }))
};
export default ProductsGridStatic;